import React from 'react'

const ScoreLow = ({ height = 30, width = 30, color = 'white' }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill="none">
            <path d="M6.52308 16.2031C5.58558 15.6406 4.46058 16.0156 3.89808 16.9531C3.33558 17.8906 3.71058 18.8281 4.64808 19.3906L14.0231 25.0156C14.5856 25.3906 15.3356 25.3906 15.8981 25.0156L25.2731 19.3906C26.2106 18.8281 26.3981 17.7031 25.8356 16.7656C25.4606 16.0156 24.3356 15.6406 23.3981 16.2031L14.9606 21.2656L6.52308 16.2031Z" fill={color} />
            <path d="M6.52308 8.12891C5.58558 7.56641 4.46058 7.75391 3.89808 8.69141C3.33558 9.62891 3.71058 10.7539 4.64808 11.3164L14.0231 16.9414C14.5856 17.3164 15.3356 17.3164 15.8981 16.9414L25.2731 11.3164C26.2106 10.7539 26.3981 9.62891 25.8356 8.69141C25.2731 7.75391 24.1481 7.56641 23.2106 8.12891L14.9606 13.1914L6.52308 8.12891Z" fill={color} />
        </svg>
    )
}

export default ScoreLow